/**
 * Wait for an external api to becomes available (by calling the getApi() function).
 * When it is ready, invoke the callback function with the api as sole param.
 *
 * @param getApi
 * @param callback
 * @param label
 * @param attempts
 * @param retries
 * @param interval
 * @returns {*|string}
 */
export function awaitApi({
  getApi,     // function that return an api (anything truthy!), or null when not yet ready
  callback,   // function that takes api as its only param
  label = 'unknownApi',
  attempts = 0,
  retries = 100,     // max retries
  interval = 200, // how long to wait
}) {
  let api = getApi();
  if (api) {
    // function, object, whatever, it's up to the callback function to know what to do with it.
    return callback(api);
  } else if (attempts > retries) {
    console.warn(`awaitApi(${label}): retry count exceeded`);
    return 'fail';
  }

  // Try again after an interval.
  let tryAgain = () => awaitApi({
    getApi, callback, label,
    attempts: attempts + 1, retries, interval
  })

  window.setTimeout(tryAgain, interval);

}
